<template>
  <v-app-bar elevation="0" class="topbar">
    <v-btn
      icon
      @click="toggleSidebar"
      class="hamburger-btn"
      :class="{ 'mobile-only': !isMobile }"
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>

    <v-toolbar-title class="mobile-title">
      <h3>{{ $route.name }}</h3>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <div class="topbar-actions">
      <v-btn icon href="/user">
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>
    </div>
  </v-app-bar>
</template>

<script>
export default {
  name: "SimpleTopbar",
  props: {
    sidebarOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 960;
    },
    toggleSidebar() {
      this.$emit("toggle-sidebar");
    },
  },
};
</script>

<style scoped>
.topbar {
  background: white !important;
  border-bottom: 1px solid #e0e0e0;
}

.hamburger-btn {
  margin-right: 16px;
}

.mobile-only {
  display: none;
}

@media (max-width: 959px) {
  .mobile-only {
    display: flex;
  }
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.v-toolbar-title h3 {
  margin: 0;
  font-weight: 400;
  color: #333;
}

@media (max-width: 959px) {
  .mobile-title {
    flex: 1 1 auto !important;
    max-width: calc(100vw - 120px) !important;
  }

  .v-toolbar-title h3 {
    font-size: 0.9rem;
    line-height: 1.1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
